import { useEffect, useState } from "react";

import { isMp4Media } from "helpers/isMp4Media";
import {
  resolveRewardBonusDisplay,
  RewardBonusSource,
} from "helpers/rewardBonusDisplay";

import styles from "./RewardBonusCell.module.scss";

type Props = RewardBonusSource & {
  onOpen?: (bonusId: number) => void;
};

const RewardBonusCell: React.FC<Props> = (props) => {
  const display = resolveRewardBonusDisplay(props);
  const imageUrl = display.mode === "entity" ? display.image : undefined;
  const [mediaFailed, setMediaFailed] = useState(false);

  useEffect(() => {
    setMediaFailed(false);
  }, [imageUrl]);

  if (display.mode === "fallback") {
    return props.onOpen ? (
      <button
        type="button"
        className={styles.trigger}
        onClick={() => props.onOpen?.(display.bonusId)}
      >
        {display.label}
      </button>
    ) : (
      <span>{display.label}</span>
    );
  }

  if (display.mode !== "entity") {
    return null;
  }

  const showMedia = Boolean(display.image) && !mediaFailed;
  const mediaIsVideo = showMedia && isMp4Media(display.image);

  const content = (
    <>
      {showMedia && mediaIsVideo && (
        <video
          src={display.image}
          muted
          playsInline
          preload="metadata"
          className={styles.mediaVideo}
          onError={() => setMediaFailed(true)}
        />
      )}
      {showMedia && !mediaIsVideo && (
        <img
          src={display.image}
          alt=""
          className={styles.media}
          onError={() => setMediaFailed(true)}
        />
      )}
      <span className={styles.details}>
        <span className={styles.title}>{display.title}</span>
        <span className={styles.id}>{`#${display.bonusId}`}</span>
      </span>
    </>
  );

  const title = `${display.title} #${display.bonusId}`;

  return props.onOpen ? (
    <button
      type="button"
      className={`${styles.cell} ${styles.trigger}`}
      title={title}
      onClick={() => props.onOpen?.(display.bonusId)}
    >
      {content}
    </button>
  ) : (
    <span className={styles.cell} title={title}>
      {content}
    </span>
  );
};

export default RewardBonusCell;
